// Static configuration. PI label per spec section 13.
export const config = {
  currentPI: 'PI-2026-Q2',
  appName: 'Guildhall',
} as const;

// Build-time injected values. See web/.env.production (created post Phase 3 deploy).
export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  userPoolId: import.meta.env.VITE_USER_POOL_ID ?? '',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
  hostedUiDomain: import.meta.env.VITE_HOSTED_UI_DOMAIN ?? '',
  region: import.meta.env.VITE_AWS_REGION ?? 'us-east-1',
} as const;
